<template>
  <b-card :header="`${this.label} no asignados`">
    <Search
      @getVoids="getVoids"
      @searchText="searchText"
      @changeQty="changeQty"
      :void="this.void"
      :file_name="`${this.label}_por_aprobar`"
      :filteredRqs="filteredServices"
      :json_fields="json_fields"
    />
    <div class="table-responsive">
      <table class="table table-bordered table-hover table-striped">
        <thead>
          <tr>
            <th>Línea naviera</th>
            <th v-if="isPos">Nave</th>
            <th>{{isPos ? 'Booking' : 'BL/BK'}}</th>
            <th v-if="isPos">Embarcador</th>
            <th
              v-if="[constants.POSICIONAMIENTOS, constants.DEVOLUCIONES].includes(service_code)"
            >Cliente</th>
            <th
              v-if="[constants.POSICIONAMIENTOS, constants.DEVOLUCIONES].includes(service_code)"
            >Facturar a</th>
            <th v-if="isPos">Depósito de retiro</th>
            <th>Solicitante</th>
            <th>Cantidad de contenedores</th>
            <th>Fecha operación</th>
            <th v-if="isPos">Fecha de llenado</th>
            <th v-if="isPos">Cutoff</th>
            <th>Estado</th>
            <th v-if="isPos">Documentos</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(service, k) in paginated('filteredServices')"
            :key="k"
            @contextmenu.prevent="selectService(service)"
          >
            <td>{{service.shipping_line.name}}</td>
            <td v-if="isPos">{{service.ship_name}}</td>
            <td>{{service.doc_number}}</td>
            <td v-if="isPos">{{service.owner_name}}</td>
            <td
              v-if="[constants.POSICIONAMIENTOS, constants.DEVOLUCIONES].includes(service_code)"
            >{{service.company ? service.company.name : ''}}</td>
            <td
              v-if="[constants.POSICIONAMIENTOS, constants.DEVOLUCIONES].includes(service_code)"
            >{{service.company ? (service.company.company_bill.name || '') : ''}}</td>
<!--            error service.requeriments[0].deposit_pick.name-->
            <td
              v-if="isPos"
            >{{service.requeriments.length ? service.requeriments[0].deposit_pick.name : '-'}}</td>
            <td>{{service.applicant.name}} {{service.applicant.last_name}}</td>
            <td>{{service.requeriments.length}}</td>
            <td>{{service.requeriments[0].date | formatDateTime}}</td>
            <td v-if="isPos">{{service.requeriments[0].date_fill | formatDateTime}}</td>
            <td v-if="isPos">{{service.cutoff | formatDateTime}}</td>
            <td>{{service.status.name}}</td>
            <td v-if="isPos">
              <button
                style="margin-bottom: 5px;"
                @click="openDoc('doc_seal', service.doc_seal)"
                v-if="service.doc_seal"
                class="btn btn-sm btn-primary"
              >
                <i class="fa fa-file" /> Precinto
              </button>&nbsp;
              <button
                @click="openDoc('doc_booking', service.doc_booking)"
                v-if="service.doc_booking"
                class="btn btn-sm btn-primary"
              >
                <i class="fa fa-file" /> Booking
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <context-menu id="context-menu" ref="ctxMenu">
      <li @click="approve()" class="ctx-item">Aprobar</li>
      <li v-if="isPos" @click="goEdit()" class="ctx-item">Editar</li>
      <li v-if="isPos" @click="cancel()" class="ctx-item">Anular</li>
    </context-menu>

    <paginate
      name="filteredServices"
      :list="filteredServices"
      class="paginate-list"
      :per="numPages"
      :refreshCurrentPage="false"
    ></paginate>
    <paginate-links
      for="filteredServices"
      :limit="5"
      :show-step-links="true"
      :step-links="{
        next: '>>',
        prev: '<<'
      }"
      :classes="{
        'ul': 'pagination',
        'li': 'page-item',
        'a': 'page-link',
      }"
    ></paginate-links>
  </b-card>
</template>

<script>
import api from "@/helpers/api";
import s3 from "@/helpers/aws";
import constants from "@/constants";
import moment from "moment";
import Search from "./Search";
import contextMenu from "vue-context-menu";

import unapproved_pos_fields from "@/helpers/json_fields/unapproved_pos_fields";
import unapproved_ree_fields from "@/helpers/json_fields/unapproved_ree_fields";
import unapproved_dev_fields from "@/helpers/json_fields/unapproved_dev_fields";

export default {
  components: { Search, contextMenu },
  data() {
    return {
      services: [],
      service: { status: {} },
      constants: {},
      statuses: [],
      paginate: ["filteredServices"],
      numPages: 100,
      search: "",
      json_fields: {},
      date: {
        start: moment(),
        end: moment()
      },
      showModalSubjects: false,
      void: this.$route.params.void,
      label: "",
      service_code: "",
      isPos: false
    };
  },
  computed: {
    filteredServices() {
      return this.services.filter(service => {
        let condition = true;
        if (this.search) {
          const textSearch = this.search.toLowerCase();
          condition = false;
          if (service.doc_number) {
            condition =
              condition ||
              service.doc_number.toLowerCase().includes(textSearch);
          }
          if (service.company) {
            condition =
              condition ||
              service.company.name.toLowerCase().includes(textSearch);
          }
          if (service.company) {
            condition =
              condition ||
              service.company.company_bill.name.toLowerCase().includes(textSearch);
          }
          if (service.ship_name) {
            condition =
              condition || service.ship_name.toLowerCase().includes(textSearch);
          }
          if (service.owner_name) {
            condition =
              condition ||
              service.owner_name.toLowerCase().includes(textSearch);
          }
          if (service.applicant) {
            condition =
              condition ||
              `${service.applicant.name} ${service.applicant.last_name}`
                .toLowerCase()
                .includes(textSearch);
          }
          if (service.status) {
            condition =
              condition ||
              service.status.name.toLowerCase().includes(textSearch);
          }
          if (service.shipping_line) {
            condition =
              condition ||
              service.shipping_line.name.toLowerCase().includes(textSearch);
          }
        }
        return condition;
      });
    }
  },
  mounted() {
    this.constants = constants;
    api.get("/statuses").then(response => {
      this.statuses = response.status;
      this.cancelledStatus = this.statuses.find(
        x => x.code === constants.ANULADO_TRAMARSA
      );
    });
    this.getVoids(this.date);
    this.isPos = this.service_code === constants.POSICIONAMIENTOS;
  },
  methods: {
    getServiceCode() {
      switch (this.void) {
        case "redeliveries":
          this.service_code = constants.REENTREGAS;
          this.label = "Reentregas";
          this.json_fields = unapproved_ree_fields;
          break;
        case "devolutions":
          this.service_code = constants.DEVOLUCIONES;
          this.label = "Devoluciones";
          this.json_fields = unapproved_dev_fields;
          break;
        case "positioning":
          this.service_code = constants.POSICIONAMIENTOS;
          this.label = "Posicionamientos";
          this.json_fields = unapproved_pos_fields;
          break;
      }
      return this.service_code;
    },
    goEdit() {
      let route = this.$router.resolve({
        path: `/voids/edit/${this.service.id}`
      });
      window.open(route.href, "_blank");
    },
    cancel() {
      const rqs = this.service.requeriments.map(rq => ({ id: rq.id }));
      const data = {
        status_id: this.cancelledStatus.id,
        requeriments: JSON.stringify(rqs)
      };
      api.put(`/service/${this.service.id}`, data).then(response => {
        if (response.success) {
          let index = this.services.findIndex(r => r.id === this.service.id);
          if (index >= 0) this.services.splice(index, 1);
          this.$toastr.success("Requerimiento anulado", "", {
            positionClass: "toast-top-center",
            closeButton: true
          });
        }
      });
    },
    getVoids(date) {
      let data = {
        start_date: moment(date.start).format("YYYY-MM-DD 00:00:00"),
        end_date: moment(date.end).format("YYYY-MM-DD 23:59:59"),
        status_code: [constants.PENDIENTE],
        service_type_code: [this.getServiceCode()]
      };

      api.post("/company_services", data).then(response => {
        this.services = response.services;
      });
    },
    detail() {
      this.$router.push(`/voids/${this.void}/detail/${this.rq.id}`);
    },
    selectService(service) {
      if (this.$can("approve", "Voids")) this.$refs.ctxMenu.open();
      this.service = service;
    },
    searchText(text) {
      this.search = text;
    },
    changeQty(num) {
      this.numPages = num;
    },
    approve(service) {
      api
        .post("approve_requeriments", { service_id: this.service.id })
        .then(response => {
          let index = this.services.findIndex(r => r.id === this.service.id);
          this.$toastr.success("Servicio aprobado", "Servicio", {
            positionClass: "toast-top-center",
            closeButton: true
          });
          if (index >= 0) {
            this.services.splice(index, 1);
          }
        });
    },
    openDoc(folder, doc) {
      const url = s3.getSignedUrl("getObject", {
        Bucket: `${process.env.VUE_APP_AWS_BUCKET}/${folder}`,
        Key: doc,
        Expires: 60
      });
      window.open(url, "_blank");
    }
  }
};
</script>

